import { useState } from "react";
import { Inbox } from "lucide-react";
import { Skeleton } from "@/components/ui/skeleton";
import { EmptyState } from "@/components/shared/empty-state";
import { useMdfRequests } from "./use-mdf-requests";
import { MdfRequestsTable } from "./requests-table";
import { RequestDrawer } from "./request-drawer";

// Sub-bucket 15 — fund-scoped Requests tab. Uses the same useMdfRequests
// hook + table + drawer as the cross-fund queue page, with `fundId` set so
// the request list narrows to this fund. No toolbar — the simpler scoped
// view is enough; the cross-fund queue carries the filter chips.

export function FundRequestsTab({ fundId }: { fundId: string }) {
  const query = useMdfRequests({ fundId });
  const [selectedId, setSelectedId] = useState<string | null>(null);

  return (
    <div className="space-y-4">
      {query.isLoading ? (
        <Skeleton className="h-40 w-full rounded-xl" />
      ) : query.isError ? (
        <EmptyState
          icon={Inbox}
          title="Couldn't load requests"
          description={query.error?.message ?? "Try refreshing."}
        />
      ) : (query.data ?? []).length === 0 ? (
        <EmptyState
          icon={Inbox}
          title="No requests yet"
          description="When the allocated partners submit MDF requests, they'll appear here."
        />
      ) : (
        <MdfRequestsTable
          rows={query.data ?? []}
          onSelect={setSelectedId}
          selectedId={selectedId}
        />
      )}

      <RequestDrawer
        requestId={selectedId}
        onClose={() => setSelectedId(null)}
      />
    </div>
  );
}
